import { componentSlice } from 'application/components/redux/componentSlice';
import { commonSlice } from '../commonSlice';

export const setLanguage = (language: string) => {
  return async (dispatch: any, getState: any) => {
    await dispatch(commonSlice.actions.LanguageChanged(language));
    await dispatch(componentSlice.actions.LanguageChanged({}));
  };
};
